import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  structuredData?: object;
}

export function SEOHead({
  title = "Indian Codes Hub - PIN, IFSC, STD, RTO & More Indian Codes",
  description = "Find all Indian codes in one place - PIN codes, IFSC codes, STD codes, RTO codes, railway codes, USSD codes, HTML colors, festivals, and cricket information.",
  keywords = "indian codes, pin code, ifsc code, std code, rto code, railway code, ussd code, html colors, indian festivals, cricket codes, postal code india",
  canonicalUrl = "https://codes.techkarmic.com/",
  ogImage = "/og-image.jpg",
  ogType = "website",
  structuredData
}: SEOHeadProps) {
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Indian Codes Hub",
    "description": description,
    "url": canonicalUrl,
    "publisher": {
      "@type": "Organization",
      "name": "Indian Codes Hub",
      "url": canonicalUrl
    }
  };

  const finalStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Indian Codes Hub" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Canonical & Alternate Markdown URLs */}
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" type="text/markdown" href={`${canonicalUrl.replace(/\/$/, '')}/index.md`} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Indian Codes Hub" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional Meta Tags */}
      <meta name="theme-color" content="#030213" />
      <meta name="msapplication-TileColor" content="#030213" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
    </Helmet>
  );
}
